export default __webpack_public_path__ + "static/media/More than just an art.2dbb7b9f.jpg";